import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import HomeRouter from '../pages/HomeRouter';

const MobileLandingPage = lazy(() => import('../pages/mobile-landing/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const AdminLoginPage = lazy(() => import('../pages/admin-login/page'));
const AdminDashboardPage = lazy(() => import('../pages/admin-dashboard/page'));
const AdminWorkReportPage = lazy(() => import('../pages/admin-work-report/page'));
const AdminQuotePage = lazy(() => import('../pages/admin-quote/page'));
const AdminContractsPage = lazy(() => import('../pages/admin-contracts/page'));
const AdminCompletedWorksPage = lazy(() => import('../pages/admin-completed-works/page'));
const WorkReportPage = lazy(() => import('../pages/work-report/page'));
const WorkReportAuthPage = lazy(() => import('../pages/work-report-auth/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const QuoteAuthPage = lazy(() => import('../pages/quote-auth/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomeRouter />,
  },
  {
    path: '/mobile',
    element: <MobileLandingPage />,
  },
  {
    path: '/admin',
    element: <AdminDashboardPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLoginPage />,
  },
  {
    path: '/admin/work-report',
    element: <AdminWorkReportPage />,
  },
  {
    path: '/admin/quote',
    element: <AdminQuotePage />,
  },
  {
    path: '/admin/contracts',
    element: <AdminContractsPage />,
  },
  {
    path: '/admin/completed-works',
    element: <AdminCompletedWorksPage />,
  },
  {
    path: '/work-report/auth',
    element: <WorkReportAuthPage />,
  },
  {
    path: '/r/:token',
    element: <WorkReportAuthPage />,
  },
  {
    path: '/work-report/:reportId',
    element: <WorkReportPage />,
  },
  {
    path: '/quote/auth',
    element: <QuoteAuthPage />,
  },
  {
    path: '/quote/:quoteId',
    element: <QuotePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;